import { Box, Card, Group, ScrollArea, Text } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import B2bTable from "components/reusable/b2bTable";
import ExportComponent from "utiles/export";
import { formatNumber, formatStatus } from "utiles/url";

const DriverDetail = ({ ordersList, userName, totalAmount }) => {
  const headerData = [
    {
      label: "#",
      key: "index",
      sortable: false,
      searchable: false,
      width: "5%",
      render: (_rowData, rowIndex) => <span>{rowIndex + 1}</span>,
    },
    {
      label: "Retailer Name",
      key: "retailer_name",
      sortable: false,
      searchable: true,
      width: "20%",
      render: (rowData) => <b>{formatStatus(rowData?.retailer.name)}</b>,
    },
    {
      label: "Warehouse",
      key: "warehouse_name",
      sortable: false,
      searchable: true,
      render: (rowData) => rowData?.warehouse.name,
    },
    {
      label: "Order Code",
      key: "order_code",
      sortable: false,
      searchable: true,
      render: (rowData) => rowData?.order_code,
    },
    {
      label: "Amount",
      key: "amount",
      sortable: false,
      searchable: false,
      render: (rowData) => <span>{formatNumber(rowData.amount)}</span>,
    },
    {
      label: "Date",
      key: "date_time",
      sortable: false,
      searchable: false,
      render: (rowData) => (
        <span>
          {new Date(rowData.date).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      ),
    },
  ];

  const { height } = useViewportSize();
  const computedTotal =
    totalAmount ??
    (ordersList || []).reduce((sum, row) => sum + (row.amount || 0), 0);

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      {/* Header: user name + Transactions title + Export button */}
      <Group position="apart" align="center" mb="sm" px="xs">
        <Box>
          {userName && (
            <Text weight={700} size="lg">
              {userName}
            </Text>
          )}
          <Text weight={600} size="md" color="dimmed">
            Transactions
          </Text>
        </Box>
        <ExportComponent
          data={ordersList || []}
          headers={headerData}
          reportTitle="Driver Transactions Detail"
          fileNamePrefix={`driver_${userName || "detail"}_transactions`}
          userName={userName}
          totalAmount={formatNumber(computedTotal)}
        />
      </Group>

      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <Card shadow="sm" p="lg">
          <ScrollArea>
            <B2bTable
              header={headerData}
              data={ordersList || []}
              layout={{ minWidth: 700 }}
              total={1}
              searchInput={false}
              activePage={1}
              loading={false}
            />
          </ScrollArea>
          {/* Total amount footer */}
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "12px",
              paddingRight: "8px",
            }}
          >
            <Text weight={700} size="sm">
              Total Amount: {formatNumber(computedTotal)}
            </Text>
          </Box>
        </Card>
      </ScrollArea>
    </div>
  );
};

export default DriverDetail;
